import React from "react";
var __jsx = React.createElement;
import { useTranslation } from "@i18n";
import { CDN_LINK } from "@globalConfig";
import BottomSheetPopup from "@componentsShared/BottomSheetPopup__OLD/BottomSheetPopup";
import stl from "./Tag.module.css";
import { useState } from "react";
var Tag = function Tag(_ref) {
  var tags = _ref.tags,
    value = _ref.value,
    onClick = _ref.onClick,
    withPopUp = _ref.withPopUp;
  var _useState = useState(false),
    ShowPopUp = _useState[0],
    setShowPopUp = _useState[1];
  var _useState2 = useState({
      code: "",
      description: ""
    }),
    popUpData = _useState2[0],
    setPopUpData = _useState2[1];
  var _useTranslation = useTranslation(["web_checkout_cash"]),
    t = _useTranslation.t;
  var handleClick = function handleClick(tag) {
    onClick(tag.code);
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: stl.container
  }, tags === null || tags === void 0 ? void 0 : tags.map(function (tag) {
    return /*#__PURE__*/React.createElement("span", {
      key: tag === null || tag === void 0 ? void 0 : tag.code
    }, /*#__PURE__*/React.createElement("div", {
      onClick: function onClick(e) {
        e.target === e.currentTarget && handleClick(tag);
      },
      className: stl.tagContainer
    }, /*#__PURE__*/React.createElement("div", {
      className: "".concat(stl.tagAR, " ").concat(tag.code === value ? stl.active : stl.inactive)
    }, tag.code, tag.description && /*#__PURE__*/React.createElement(React.Fragment, null, "- ", /*#__PURE__*/React.createElement("span", null, tag.description)), withPopUp && /*#__PURE__*/React.createElement("img", {
      className: "hasEvents",
      onClick: function onClick() {
        setShowPopUp(true);
        setPopUpData({
          code: tag.code,
          description: tag.popup_description
        });
      },
      src: CDN_LINK + "/assets/images/gray-info-icon.svg",
      alt: "info icon"
    }))));
  })), /*#__PURE__*/React.createElement(BottomSheetPopup, {
    show: ShowPopUp,
    onClose: function onClose() {
      setShowPopUp(false);
    },
    className: stl.customPopUp
  }, /*#__PURE__*/React.createElement("div", {
    className: stl.popupContainer
  }, /*#__PURE__*/React.createElement("strong", null, t("discount_code_3", {
    ns: "web_checkout_cash"
  }), "(", popUpData.code, ")"), /*#__PURE__*/React.createElement("p", null, popUpData.description))));
};
export default Tag;